import PropTypes from 'prop-types';
import { useEffect, useContext } from 'react';
import LiveMessageContext from './LiveMessageContext';

const LiveAnnounce = ({ message = '', 'aria-live': ariaLive = 'polite' }) => {
  const context = useContext(LiveMessageContext);
  useEffect(() => {
    if (ariaLive === 'assertive') {
      context.announceAssertive(message);
    } else if (ariaLive === 'polite') {
      context.announcePolite(message);
    }
  }, [ariaLive, context, message]);

  return null;
};

LiveAnnounce.propTypes = {
  message: PropTypes.string,
  'aria-live': PropTypes.string,
};

export default LiveAnnounce;
